export const PERFIL_COMPONENT_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1"
        }
    },
    tabs: {
        list: "inline-flex h-10 items-center justify-start rounded-xl bg-gray-50 border border-gray-100 p-1 gap-1",
        trigger: "inline-flex items-center gap-1.5 rounded-lg px-3.5 py-1.5 text-xs font-medium text-gray-500 transition-all data-[state=active]:bg-white data-[state=active]:text-gray-900 data-[state=active]:shadow-sm data-[state=active]:border data-[state=active]:border-gray-100"
    },
    section: {
        card: "bg-white rounded-xl border border-gray-100 p-6",
        titleRow: "flex items-center gap-2.5 mb-5",
        iconBox: "w-9 h-9 rounded-xl flex items-center justify-center bg-violet-50",
        icon: "text-violet-600",
        title: "text-sm font-semibold text-gray-900",
        description: "text-xs text-gray-500 mt-0.5"
    },
    avatar: {
        container: "mb-2",
        wrapper: "flex items-center gap-4",
        imageContainer: "relative w-20 h-20 rounded-2xl bg-violet-50 flex items-center justify-center overflow-hidden cursor-pointer group shrink-0",
        image: "w-full h-full object-cover",
        placeholder: "text-violet-300",
        overlay: "absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity",
        name: "text-sm font-semibold text-gray-900",
        email: "text-xs text-gray-500 mt-0.5",
        changeButton: "text-xs font-medium text-[#7C3AED] hover:text-[#6d28d9] mt-1.5 transition-colors"
    },
    dialog: {
        backdrop: "fixed inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200",
        container: "fixed inset-0 z-[9999] flex items-center justify-center",
        panel: "relative bg-white rounded-2xl border border-gray-100 shadow-xl shadow-gray-200/50 w-full max-w-md p-6 animate-in fade-in slide-in-from-bottom-4 duration-300",
        title: "text-lg font-bold text-gray-900",
        separator: "h-px bg-gray-100 my-4",
        description: "text-sm text-gray-600 leading-relaxed",
        actions: "flex items-center justify-end gap-3 mt-6",
        cancelButton: "h-9 px-4 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors",
        confirmButton: "h-9 px-5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-semibold rounded-lg shadow-sm shadow-[#7C3AED]/20 transition-all active:scale-95"
    }
};
